/** Mirrors the dev13 Contact serializer (apps/crm/serializers.py). */
export interface Contact {
  id: number;
  public_id: string;
  company: number | null;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  title: string;
  notes: string;
  is_archived: boolean;
  archived_at: string | null;
  created: string;
  modified: string;
}

/** Write payload — matches ContactWriteSerializer fields. */
export interface ContactInput {
  company: number | null;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  title: string;
  notes: string;
}

export const contactName = (c: Pick<Contact, 'first_name' | 'last_name' | 'email'>): string =>
  `${c.first_name} ${c.last_name}`.trim() || c.email || 'Contact';
